window.ContentSectionSwitcher = (randomId) => {
    return {
        container: null,
        activeTab: null,
        init() {
            this.container = document.querySelector(`#ContentSectionSwitcher-${randomId}`);
            // get id="section-buttons-{{ randomId }}" and move it into the class="panel-buttons-container" div
            const sectionButtons = document.querySelector(`#SectionButtons-${randomId}`);
            const panelButtonsContainer = this.container.querySelector('.panel-buttons-container');
            if (sectionButtons && panelButtonsContainer) {
                panelButtonsContainer.appendChild(sectionButtons);
            }
        },
        // scroll to top of active section
        scrollToActiveSection() {
          setTimeout(() => {
        	let activeSection = document.getElementById(this.activeTab);
        	activeSection.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 250);
        },
    }
}